import { Injectable } from "@angular/core";
import type { Resolve } from '@angular/router';
import { ConstantAuthorFacade } from '@medsurf/flat-facades';

@Injectable({
  providedIn: "root"
})
export class StainsAuthorResolver implements Resolve<void> {
  constructor(protected constantAuthorFacade: ConstantAuthorFacade) {
  }

  resolve() {
    return this.constantAuthorFacade.requestGetStains();
  }
}